import {HomePage } from "../../pages/HomePage";
import {BouquetsPage } from "../../pages/BouquetsPage";
import {AboutPage } from "../../pages/AboutPage";
import {DeliveryUfaPage } from "../../pages/DeliveryUfaPage";
import {DeliveryBulgakovoPage } from "../../pages/DeliveryBulgakovoPage";
import {CustomBouquetsPage } from "../../pages/CustomBouquetsPage";
import {WeddingFloristryPage } from "../../pages/WeddingFloristryPage";
import {IndoorPlantsPage } from "../../pages/IndoorPlantsPage";
import {BlogPage } from "../../pages/BlogPage";
import {BlogArticlePage } from "../../pages/BlogArticlePage";
import { App } from '../App'
import { createBrowserRouter } from "react-router";

export const router = createBrowserRouter([
    {
        path: "/",
        Component: App,
        children: [
            {path: "/", Component: HomePage},
            {path: "/bouquets", Component: BouquetsPage},
            {path: "/catalog", Component: BouquetsPage},
            {path: "/about", Component: AboutPage},
            {path: "/dostavka-ufa", Component: DeliveryUfaPage},
            {path: "/dostavka-bulgakovo", Component: DeliveryBulgakovoPage},
            {path: "/bukety-na-zakaz", Component: CustomBouquetsPage},
            {path: "/svadebnaya-floristika", Component: WeddingFloristryPage},
            {path: "/komnatnye-rasteniya", Component: IndoorPlantsPage},
            {path: "/blog", Component: BlogPage},
            {path: "/blog/:slug", Component: BlogArticlePage}
        ]
    }
]);